import Ajax from '@/lib/ajax'

export default {
  // 获取任务列表
  getTaskList(pageSize: number, currentPage: number) {
    let params = {
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize
    }
    return Ajax.get(`/api/Report/ExportTask/GetExportTaskAsync`, {
      params
    })
  },
  // 订单任务下载
  orderTaskDown(id: string) {
    let params = {
      id
    }
    return Ajax.get(`/api/OrderManagement/order/OrderFileDownload`, {
      params,
      responseType: 'blob',
    })
  },
  // 分销任务下载
  distributorTaskDown(id: string) {
    let params = {
      id
    }
    return Ajax.get(`/api/distribution/distributionOrder/GetBrokerageReportFile`, {
      params,
      responseType: 'blob',
    })
  }
}